class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      const updates = this.prepareUpdates(parsedState);
      this.cartItemKey = parsedState.key;
      updates.forEach(({ target, html }) => { target.innerHTML = html; });

      if (this.header) this.header.reveal();
      this.open();
  }

  prepareUpdates(parsedState) {
    if (!parsedState || typeof parsedState !== 'object') {
      throw new Error('Cart notification response is incomplete');
    }
    const { key, sections } = parsedState;
    if (typeof key !== 'string' || !key || !sections || typeof sections !== 'object') {
      throw new Error('Cart notification response is incomplete');
    }

    return this.getSectionsToRender(key).map((section) => {
      const target = document.getElementById(section.id);
      if (!target) throw new Error(`Cart notification target is missing: ${section.id}`);
      return { target, html: this.getSectionInnerHTML(sections[section.id], section.selector) };
    });
  }

  getSectionsToRender(cartItemKey = this.cartItemKey) {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string') throw new Error('Cart notification section is missing');
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!node) throw new Error('Cart notification rendered node is missing');
    return node.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
